class gMap {
  constructor(addrs) {
    this.map = null;
    this.markers = [];
    this.infowindows = [];
    this.addrs = addrs;
    this.styleID = null;
    this.custom_marker = null;
    if (globalFields?.gmap_id) {
      this.styleID = globalFields.gmap_id;
    }

    if (addrs.length > 0) {
      this.initMap();
    } else {
      console.log("No addresses found");
    }
  }

  async initMap() {
    const { Map } = await google.maps.importLibrary("maps");
    let addrs = this.addrs;
    if (globalFields?.custom_marker) {
      this.custom_marker = {
        url: globalFields.custom_marker,
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(25, 50),
      };
    }
    let custom_icon = this.custom_marker;

    this.map = new Map(document.getElementById("maps"), {
      center: this.getMiddleCoord(),
      zoom: addrs[0].address.zoom,
      mapId: this.styleID,
      rotateControl: false,
      fullscreenControl: false,
      screenViewControl: false,
      rotateControl: false,
      disableDefaultUI: true,

    });

    for (let addr of addrs) {
      let coords = {
        lat: parseFloat(addr.address.lat),
        lng: parseFloat(addr.address.lng),
      };
      let title = addr.place_label;
      // Format address
      let link = `https://www.google.com/maps?q=${addr.address.address}`;
      if (addr.marker) {
        custom_icon = {
          url: addr.marker,
          scaledSize: new google.maps.Size(50, 50),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(25, 50),
        };
      }

      const marker = new google.maps.Marker({
        position: coords,
        map: this.map,
        title: title,
        icon: custom_icon,
      });

      custom_icon = this.custom_marker;

      const infowindow = new google.maps.InfoWindow({
        content: `<div class="info-window"><h4>${title}</h4><a target="_blank" href="${link}">Get directions</a></div>`,
      });

      infowindow.open(this.map, marker);
    }
  }

  getMiddleCoord() {
    let lat = 0;
    let lng = 0;
    for (let addr of this.addrs) {
      lat += parseFloat(addr.address.lat);
      lng += parseFloat(addr.address.lng);
    }
    return { lat: lat / this.addrs.length, lng: lng / this.addrs.length };
  }
}

document.addEventListener("DOMContentLoaded", async function () {
  let map;
  let addrs = null;
  if (window.fields) addrs = window.fields?.addrs;
  if (!addrs) return;

  new gMap(addrs);
});
